module.exports = __webpack_public_path__ + "media/images/common/fp/icon-area-af316cb4c3a305cf4e64093b38337994.svg";